import { ModuleWithProviders, NgModule } from '@angular/core';
import { ImageConverterProvider } from '@services/files/image-converter.service';
import { WorkflowDragNDropProvider } from '@services/workflow/workflow-drag-n-drop';
import { ClientsDataServiceProvider } from '@services/client/clients.data.service';
import { PaymentsServiceProvider } from '@services/payments/payments-service/payments.service';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { SearchService } from '@services/helpers/search.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { CalendarEventsDataProvider } from '@services/calendar/calendar-events.data.service';
import { WorkflowProvider } from '@services/workflow/workflow-service/workflow.service';
import { RandomStringGeneratorProvider } from '@services/helpers/random-string-generator';
import { MailsDataProvider } from '@services/email/mails.data.service';
import { WorkflowDataProvider } from '@services/workflow/workflow.data.service';
import { ValidationProvider } from '@services/helpers/validation.service';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ClientServiceProvider } from '@services/client/client.service';
import { IntegrationsDataProvider } from '@services/integrations/integrations.data.service';
import { ContractsDataProvider } from '@services/contract/contracts.data.service';
import { UtilsServiceProvider } from '@services/utils/utils-service';
import { AppointmentServiceProvider } from '@services/tasks/appointment.service';
import { ExtraShootServiceProvider } from '@services/tasks/extra-shoot.service';
import { TemplatesDataProvider } from '@services/data-services/templates-data-service/templates.data.service';
import { TimeConverterProvider } from '@services/helpers/time-converter';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { NotesDataServiceProvider } from '@services/notes/notes.data.service';
import { QuestionnairesDataProvider } from '@services/questionnarie/questionnaires.data.service';
import { EmailSettingsDataService } from '@services/settings/email-settings.data.service';
import { AccountDataServiceProvider } from '@services/user/account.data.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { AccountServiceProvider } from '@services/user/account.service';
import { UserServiceProvider } from '@services/user/user.service';
import { PromoCodeProvider } from '@services/subscription/promo-code.service';
import { PromoCodeDataProvider } from '@services/subscription/promo-code.data.service';
import { StripeDataProvider } from '@services/subscription/stripe.data.service';
import { StripeServiceProvider } from '@services/subscription/stripe-service';
import { LeadsDataServiceProvider } from '@services/lead/leads.data.service';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { PaymentsDataServiceProvider } from '@services/payments/payments-data-service/payments.data.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { JobTypesDataProvider } from '@services/job/job-types.data.service';
import { SettingsProvider } from '@services/settings/settings';
import { InvoiceServiceProvider } from '@services/invoice/invoice-service/invoice.service';
import { ContractsServiceProvider } from '@services/contract/contracts-service/contracts.service';
import { QuestionnairesServiceProvider } from '@services/questionnarie/questionnaires-service/questionnaires.service';
import { ProductPackagesServiceProvider } from '@mob-providers/product-packages-service/product-packages.data.service';
import { FileDownloadDataServiceProvider } from '@services/files/file-download-service/file-download.data.service';
import { PaymentSchedulesDataProvider } from '@services/payments/payments-schedules-data-service/payments-schedules.data.service';
import { JobServiceProvider } from '@services/job/job.service';
import { LeadServiceProvider } from '@services/lead/lead.service';
import { AmbassadorService } from '@web-services/admin/ambassadors/ambassador.service';
import { AdminUsersDataService } from '@web-services/admin/users/admin-users.data.service';
import { AdminReportsDataService } from '@web-services/admin/users/admin-reports.data.service';
import { PaginationService } from '@services/pagination/pagination.service';
import { CalendarServiceProvider } from '@services/calendar/calendar.service';
import { CalendarIntegrationProvider } from '@services/calendar-integration/calendar-integration.service';
import { CompanySettingsServiceProvider } from '@services/settings/company-settings';
import { SubscriptionServiceProvider } from '@services/subscription/subscription.old.service';
import { DashboardDataServiceProvider } from '@services/dashboard/dashboard.data.service';
import { GraphsDataServiceProvider } from '@web-components/dashboard/graphs-block/graphs.data.service';
import { GraphsService } from '@web-services/graph/graphs.service';
import { ProductPackagesDataServiceProvider } from '@services/settings/product-packages.data.service';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { ProfileUpdateDataServiceProvider } from '@web-services/profile/profile-update.data.service';
import { ShootProofDataProvider } from '@services/integrations/shootProof/shootProof.data.service';
import { AuthTokensService } from '../auth-tokens.service';
import { ProfileUpdateServiceProvider } from '@web-services/profile/profile-update.service';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SettingsDataService } from '@services/settings/settings.data.service';
import { BrandsServiceProvider } from '@services/brands/brands.service';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { SettingsOverviewDataProvider } from '@web-services/settings/settings-overview/settings-overview.data.service';
import { HttpServiceProvider } from '@services/helpers/http.service';

@NgModule({
	declarations: [],
	providers: [],
	imports: [],
	exports: []
})
export class WebServicesModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: WebServicesModule,
			providers: [
				AdminReportsDataService,
				AdminUsersDataService,
				AmbassadorService,
				CalendarServiceProvider,
				SearchService,
				MessageService,
				AppointmentServiceProvider,
				ValidationProvider,
				TimeServiceProvider,
				ClientsDataServiceProvider,
				CompanySettingsServiceProvider,
				TimeConverterProvider,
				ClientServiceProvider,
				ExtraShootServiceProvider,
				ImageConverterProvider,
				CalendarEventsDataProvider,
				CalendarServiceProvider,
				StringModifierServiceProvider,
				RandomStringGeneratorProvider,
				IntegrationsDataProvider,
				TemplatesDataProvider,
				PaymentsServiceProvider,
				InvoicesDataProvider,
				WorkflowDataProvider,
				WorkflowProvider,
				WorkflowDragNDropProvider,
				EmailServiceProvider,
				MailsDataProvider,
				UtilsServiceProvider,
				NotesDataServiceProvider,
				FileUploadDataProvider,
				FileUploadServiceProvider,
				FileDownloadDataServiceProvider,
				QuestionnairesDataProvider,
				ContractsDataProvider,
				EmailSettingsDataService,
				AccountDataServiceProvider,
				AccountServiceProvider,
				AuthTokensService,
				UserServiceProvider,
				PromoCodeProvider,
				PromoCodeDataProvider,
				StripeDataProvider,
				StripeServiceProvider,
				LeadsDataServiceProvider,
				JobsDataServiceProvider,
				InvoicesDataProvider,
				PaymentsDataServiceProvider,
				ContractsDataProvider,
				NotesDataServiceProvider,
				QuotesDataProvider,
				JobTypesDataProvider,
				WorkflowDataProvider,
				SettingsProvider,
				InvoiceServiceProvider,
				ContractsServiceProvider,
				QuestionnairesServiceProvider,
				ProductPackagesServiceProvider,
				PaymentSchedulesDataProvider,
				JobServiceProvider,
				LeadServiceProvider,
				PaymentSchedulesDataProvider,
				PaginationService,
				CalendarIntegrationProvider,
				SubscriptionServiceProvider,
				DashboardDataServiceProvider,
				GraphsDataServiceProvider,
				GraphsService,
				ProductPackagesDataServiceProvider,
				QuoteUpdateService,
				ProfileUpdateDataServiceProvider,
				ShootProofDataProvider,
				ProfileUpdateServiceProvider,
				NewSubscriptionServiceDataProvider,
				IframeService,
				SNModalService,
				SettingsDataService,
				BrandsServiceProvider,
				BrandsDataServiceProvider,
				SettingsOverviewDataProvider,
				HttpServiceProvider
			]
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/services/services.module.ts